import {
  getCustomerSession,
  updateCurrentPage,
} from 'widget_main/globals/session';
import { getKustomerCore } from 'widget_main/globals/helpers';
import { CustomerDetails } from 'core_main/sdk/get_assistant/types';
import { getMappedLanguage } from 'i18n/helpers';
import { InitAssistantCallbackResponse } from 'core_main/sdk/init_assistant/types';

export const findPageCondition = (condition) =>
  !!condition.session_currentPage ||
  !!condition.session_previousPage ||
  !!condition.currentPageSeconds;

export const findPageCriteria = (rule) => {
  const or = rule.criteria?.and?.find(findPageCondition);
  const and = rule.criteria?.or?.find(findPageCondition);

  return or || and;
};

export const startUpdatePageInterval = (settings) => {
  const { assistantRules } = settings;

  if (!assistantRules?.length) return undefined;

  const containsPageCriteria = assistantRules.find(findPageCriteria);

  if (containsPageCriteria) {
    return setInterval(() => {
      updateCurrentPage();
    }, 500);
  }

  return undefined;
};
export const getDefaultAssistant = (): Promise<
  Maybe<InitAssistantCallbackResponse>
> => {
  const settings = getKustomerCore().getChatSettings();
  if (settings.activeAssistant)
    return getKustomerCore().initAssistant({
      assistant: settings.activeAssistant,
      lang: getMappedLanguage(),
    });
  return Promise.resolve(undefined);
};

export const getActiveAssistant = (
  options: {
    customer?: CustomerDetails;
    proactiveOnly?: boolean;
    assistant?: string;
    dialog?: string;
  } = {},
): Promise<InitAssistantCallbackResponse | false> => {
  const activeAssistant = options.assistant
    ? {
        assistant: options.assistant,
        dialog: options.dialog,
      }
    : getKustomerCore().getAssistant({
        ...options,
        session: getCustomerSession(),
      });
  if (!activeAssistant) return Promise.resolve(false);
  return getKustomerCore()
    .initAssistant({
      ...activeAssistant,
      lang: getMappedLanguage(),
    })
    .catch(() => {
      return getDefaultAssistant();
    });
};
